<template>
<div>
    <plantVariety-form :getPlantVarietyList="getPlantVarietyList" ref="plantVarietyFormModal"></plantVariety-form>
    <div class="custom-search">
        <b-row class="mb-1">
            <b-col class="col-md-2">
                <label for="plantVariety-record-no-input">{{ $t('plantVariety.record_no') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="recordNo" :placeholder="$t('plantVariety.record_no')" type="text" class="d-inline-block" />
                </div>
            </b-col>
            <b-col class="col-md-2">
                <label for="plantVariety-agent-input">{{ $t('plantVariety.agent') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="agentName" :placeholder="$t('plantVariety.agent')" type="text" class="d-inline-block" />
                </div>
            </b-col>
            <b-col class="col-md-2">
                <label for="plantVariety-owner-name-input">{{ $t('plantVariety.owner_name') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="ownerName" :placeholder="$t('plantVariety.owner_name')" type="text" class="d-inline-block" />
                </div>
            </b-col>
            <b-col class="col-md-2">
                <label for="plantVariety-application-no-input">{{ $t('plantVariety.application_no') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="applicationNo" :placeholder="$t('plantVariety.application_no')" type="text" class="d-inline-block" />
                </div>
            </b-col>
            <b-col class="col-md-4 mt-2 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getPlantVarietyList()" @click="getPlantVarietyList()">{{ $t('others.list') }}</b-button>
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="getInfo(0)">{{$t('plantVariety.add') }}</b-button>
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" @click="clearSearchForm">
                        {{ $t('others.clear') }}
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table id="plantVarietyTable" ref="plantVarietyTable" :columns="columns" :rows="rows" :search-options="{
      enabled: true,
      externalQuery: searchTerm,
    }" styleClass="vgt-table condensed tableSize" :select-options="{
  enabled: false,
  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
  selectionInfoClass: 'custom-class',
  selectionText: 'rows selected',
  clearSelectionText: 'clear',
  disableSelectInfo: true, // disable the select info panel on top
  selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
}" :pagination-options="{
  enabled: true,
  perPage: pageLength
}" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'recordNo'" class="text-nowrap">
                {{ $t('plantVariety.record_no') }}
            </span>
            <span v-else-if="props.column.field === 'applicationNo'" class="text-nowrap">
                {{ $t('plantVariety.application_no') }}
            </span>
            <span v-else-if="props.column.field === 'varietyName'" class="text-nowrap">
                {{ $t('plantVariety.variety_name') }}
            </span>
            <span v-else-if="props.column.field === 'agent'" class="text-nowrap">
                {{ $t('plantVariety.agent_name') }}
            </span>
            <span v-else-if="props.column.field === 'ownerList'" class="text-nowrap">
                {{ $t('plantVariety.owners') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Agent Name -->
            <span v-if="props.column.field === 'agent'" class="text-nowrap">
                <b-row>
                    <b-col class="font-size: x-small">
                        <span>{{ props.row.agent }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <span class="font-size: small">{{ props.row.clientAccounting }}</span>
                    </b-col>
                </b-row>
            </span>
            <span v-else-if="props.column.field === 'applicationNo'" class="text-nowrap">
                <b-row>
                    <b-col class="font-size: x-small">
                        <span>{{ props.row.applicationNo }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <span class="font-size: small">{{ $formatFn(props.row.applicationDate) }}</span>
                    </b-col>
                </b-row>
            </span>
            <span v-else-if="props.column.field === 'plantVarietyType'" class="text-nowrap">
                <b-row>
                    <b-col class="font-size: x-small">
                        <span>{{ props.row.plantVarietyType }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <span class="font-size: small">{{ props.row.plantVarietyPublicationType }}</span>
                    </b-col>
                </b-row>
            </span>
            <span v-else-if="props.column.field === 'ownerList'">
                <b-col>
                    <b-row v-for="owner in props.row.ownerList" v-bind:data="owner" v-bind:key="owner.clientName" style="font-size: small;">
                        <tr v-if="props.row.ownerList.length != 1">
                            <feather-icon class="featherIconReSize" icon="ArrowRightIcon" />
                            <span>{{ owner.clientName }} </span> <br />
                        </tr>
                        <tr v-else-if="props.row.ownerList.length == 1">
                            <span>{{ owner.clientName }} </span> <br />
                        </tr>
                    </b-row>
                </b-col>
            </span>
            <span v-else-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }} </span>
                    <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getPlantVarietyList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    watch: {
        applicationDateStart(newValue) {
            if (newValue == '') {
                this.applicationDateStart = null
            }
        },
        applicationDateEnd(newValue) {
            if (newValue == '') {
                this.applicationDateEnd = null
            }
        },
    },
    data() {
        return {
            total: 0,
            pageLength: 10,
            dir: false,
            pageNo: 1,
            columns: [{
                    label: this.$t('plantVariety.folder_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('plantVariety.application_no'),
                    field: `applicationNo`,
                },
                {
                    label: this.$t('plantVariety.variety_name'),
                    field: `varietyName`,
                },
                {
                    label: this.$t('plantVariety.agent_name'),
                    field: `agent`,
                },
                {
                    label: this.$t('plantVariety.owners'),
                    field: `ownerList`,
                    sortable: false,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em',
                    sortable: false,
                },
            ],
            rows: [],
            searchTerm: '',
            agentName: '',
            recordNo: '',
            applicationNo: '',
            plantVarietyStatusSelect: 0,
            plantVarietyStatusOption: [],
            ownerName: '',
            applicationDateStart: null,
            applicationDateEnd: null,
        }
    },
    mounted() {
        this.getPlantVarietyList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'PlantVariety'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getPlantVarietyList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getPlantVarietyList()
                        }
                    })
                }
            })
        },

        async getInfo(id) {
            this.$refs.plantVarietyFormModal.showInfo(id, this.plantVarietyId)
        },

        getPlantVarietyList() {
            let loader = this.$loading.show()
            this.rows = []
            if (this.applicationDateStart == '') {
                this.applicationDateStart = null

            }
            if (this.applicationDateEnd == '') {
                this.applicationDateEnd = null

            }
            const controller = {
                name: 'PlantVariety'
            }
            const data = {
                recordNo: this.recordNo,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                agentName: this.agentName,
                plantVarietyStatusId: this.plantVarietyStatusSelect,
                ownerName: this.ownerName,
                plantVarietyPublicationTypeId: this.plantVarietyPublicationTypeSelect,
                plantVarietyTypeId: this.plantVarietyTypeSelect,
                applicationDateStart: this.applicationDateStart,
                applicationDateEnd: this.applicationDateEnd,
                applicationNo: this.applicationNo,
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    response.data.plantVarietyList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.plantVarietyStatusOption = response.data.plantVarietyStatusList
                    this.plantVarietyStatusOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        exportExcel() {

            if (this.applicationDateStart == '') {
                this.applicationDateStart = null

            }
            if (this.applicationDateEnd == '') {
                this.applicationDateEnd = null

            }
            var controller = {
                name: 'PlantVariety'
            }
            var data = {
                recordNo: this.recordNo,
                pageLength: this.total,
                pageNo: 1,
                agentName: this.agentName,
                plantVarietyStatusId: this.plantVarietyStatusSelect,
                ownerName: this.ownerName,
                plantVarietyPublicationTypeId: this.plantVarietyPublicationTypeSelect,
                plantVarietyTypeId: this.plantVarietyTypeSelect,
                applicationDateStart: this.applicationDateStart,
                applicationDateEnd: this.applicationDateEnd,
                applicationNo: this.applicationNo,
            }
            var payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    controller = {
                        name: 'PlantVariety',
                        actionName: 'CanExport'
                    }
                    data = {
                        columnList: this.columns,
                        DataList: response.data.plantVarietyList
                    }
                    payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$downloadFile("PlantVariety", response.data.base64, 'xlsx')
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clearSearchForm() {
            // Form alanlarını temizle
            this.recordNo = '';
            this.agentName = '';
            this.ownerName = '';
            this.applicationNo = '';
            this.plantVarietyStatusSelect = 0;
            this.plantVarietyTypeSelect = 0;
            this.applicationDateStart = null;
            this.applicationDateEnd = null;
            // Tabloyu yenile
            this.getPlantVarietyList();
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

[dir] .dark-layout .card {
    background-color: #252d3f !important;
    box-shadow: 0 4px 24px 0 rgb(34 41 47 / 24%) !important;
}

.akista-d-flex {
    display: contents !important;
}

/* Solid border */
hr.solid {
    border-top: 3px solid #bbb;
}

.tableSizePlantVariety {
    font-size: 14px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.featherIconReSize {
    width: 12px;
    height: 12px;
}
</style>
